import React, { useState } from "react";
import { Button, Modal } from "antd";
import PolicyDetail from "../PolicyDetail";
import { policiesAndProceduresData } from "../PolicyDetail/data";
const PolicyModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button type="primary" onClick={showModal}>
        Upload
      </Button>
      <Modal
        centered
        width={"95vw"}
        title="Behaviour Support Plan - Comprehensive"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        className="policyModal"
      >
        <div className="modalBody">
          <PolicyDetail data={policiesAndProceduresData} bgColor={"#F1F4F8"} />
        </div>
      </Modal>
    </>
  );
};
export default PolicyModal;
